var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGpsMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.917,
    height: 28.45,
    viewBox: "1120.983 3807.983 19.917 28.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1130.94 3808c-5.489 0-9.94 4.45-9.94 9.942a9.84 9.84 0 0 0 .954 4.258c3.132 7.228 8.987 14.207 8.987 14.207s5.841-6.98 8.973-14.207a9.85 9.85 0 0 0 .97-4.258 9.94 9.94 0 0 0-9.943-9.942Zm0 14.825a4.884 4.884 0 1 1 0-9.769 4.884 4.884 0 1 1 0 9.769Z",
    fill: "#357fd8",
    fillRule: "evenodd",
    "data-name": "Path 78"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsMarker);
export default __webpack_public_path__ + "static/media/gpsMarker.8683599ed544ab00a66e33d9cc91d3e6.svg";
export { ForwardRef as ReactComponent };